'use client';

import { ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { CheckboxContext } from '../CheckboxContext/CheckboxContext';
import './Scrollbar.css';

interface ScrollableProps {
  children: ReactNode;
  required: boolean;
}

export function Scrollable({ children, required }: ScrollableProps) {
  const [reachedBottom, setReachedBottom] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  const { disabled, setDisabled } = useContext(CheckboxContext);
  const isRequired = required ?? false;
  useEffect(() => {
    if (reachedBottom) {
      setDisabled(false);
    }
  }, [reachedBottom]);

  const checkScrollPosition = () => {
    if (divRef.current) {
      const { scrollTop, clientHeight, scrollHeight } = divRef.current;
      const atBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
      setReachedBottom(atBottom);
    }
  };

  return isRequired ? (
    <div
      className="scrollable h-[260px] table-auto rounded-t-xl border border-solid border-[#EEEDF1] bg-[#FAF9FC] px-6 [&>h1]:mb-0 [&>h1]:mt-4 [&>h1]:text-base [&>h2]:m-0 [&>h2]:pt-6 [&>h2]:text-xl [&>h3]:m-0 [&>h3]:pb-4 [&>h3]:pt-0 [&>h3]:text-xl [&>h4]:m-0 [&>h5]:m-0 [&>h5]:text-base [&>h6]:m-0 [&>h6]:text-base [&>p]:m-0 [&>p]:pb-4"
      onScroll={checkScrollPosition}
      ref={divRef}
    >
      {children}
    </div>
  ) : (
    <div
      className="scrollable h-40 table-auto rounded-md bg-[#FAF9FC] px-6 leading-4"
      ref={divRef}
    >
      {children}
    </div>
  );
}
